import { render } from "./ProductShowComponent.vue?vue&type=template&id=94366dfe"
import script from "./ProductShowComponent.vue?vue&type=script&lang=js"
export * from "./ProductShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ProductShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94366dfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94366dfe', __exports__)) {
    api.reload('94366dfe', __exports__)
  }
  
  module.hot.accept("./ProductShowComponent.vue?vue&type=template&id=94366dfe", () => {
    api.rerender('94366dfe', render)
  })

}


export default __exports__